<div class="p-grid p-jc-center">
    <div class="p-md-9 p-lg-12 ">
        <p-carousel [value]="noticias" [numVisible]="4" [numScroll]="4" [circular]="false" [responsiveOptions]="responsiveOptions">
            <ng-template let-noticia pTemplate="item">
                <div class="p-d-flex p-flex-column p-ai-center p-m-4 p-shadow-3">
                    <img  class="imgNoticia" *ngIf="vectorImagenes[noticia.id]" [src]="vectorImagenes[noticia.id]" [alt]="noticia.imagen.nombre" />
                    <img  class="imgNoticia" *ngIf="!vectorImagenes[noticia.id]" [src]="imgDefault" [alt]="noticia.imagen.nombre" />
                    <h3 class="p-mb-1 p-4">{{noticia.titulo}}</h3>
                    <h6 class="p-mt-2 p-mb-3 p-p-4">
                        <div [innerHtml]="noticia.body | slice:0:180 | formatPersonalText: 'resumenNoticia'"></div>
                    </h6>
                    <button class="p-mb-3 last-item" pButton pRipple [label]="'NOTICIAS.VER' | translate" (click)="verNoticia(noticia.id)"></button>
                </div>
            </ng-template>
        </p-carousel>
    </div>
</div>

